import styled from "styled-components";

export const Container = styled.div`
  .client-info {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }

  .client-charge {
    margin-top: 2.4rem;
  }
`;
